const routes = [{
  path: '/client',
  component: () => import('@/views/feiche/index'),
  name: 'client-manage',
  meta: {
    title: ''
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/client/client.js